import { render } from "./Blocks.vue?vue&type=template&id=41d5aa14&scoped=true"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"

import "./Blocks.vue?vue&type=style&index=0&id=41d5aa14&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d5aa14"]])

export default __exports__